import { AnalyticsEvent } from "@common/constants/analytics-events";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { SchedulesReportLayout } from "@common/types/reports/schedules-report";
import { UpgradeCta } from "@components/settings/Plans/UpgradeCta";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { trackEvent } from "@lib/analytics";

const PAYWALL_COPY: Record<
    SchedulesReportLayout,
    { reportName: string; subtitle: string }
> = {
    [SchedulesReportLayout.rollforward]: {
        reportName: "Rollforward reports",
        subtitle:
            "See opening and closing balances and period activity for every recognition schedule.",
    },
    [SchedulesReportLayout.waterfall]: {
        reportName: "Waterfall reports",
        subtitle:
            "See how recognition schedule activity breaks down across each period.",
    },
};

export const SchedulesReportPaywalled = ({
    layout,
}: {
    layout: SchedulesReportLayout;
}) => {
    useEffectOnce(() => {
        void trackEvent(AnalyticsEvent.UPSELL_SCHEDULES_REPORTS_ATTEMPTED, {
            layout,
        });
    });

    const { reportName, subtitle } = PAYWALL_COPY[layout];

    return (
        <div className="flex flex-col w-inherit">
            <UpgradeCta
                title={
                    <>
                        {reportName} are available on the{" "}
                        <span className="text-blue-600">Advanced</span> plan
                    </>
                }
                subtitle={subtitle}
                plan={FLAT_RATE_PLANS.ADVANCED}
            />
            <img
                src="/images/features/schedules.png"
                alt="Premium feature preview"
                width="100%"
            />
        </div>
    );
};
